/** @jsxImportSource @emotion/react */

// import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
// import MarketPlaceBanner from '../../../asset/images/iStock-1212624604.jpg';

const Banner = ({ onExploreAgentsClick }: { onExploreAgentsClick: () => void }) => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // Banner temporarily commented out
  return null;
  /*
  return (
    <Box sx={{}}>
      <Box
        sx={{
          padding: isMobile ? '100px 15px 120px' : '110px 15px 40px',
          backgroundImage: `url(${MarketPlaceBanner})`,
          backgroundSize: 'cover', // Ensure the image covers the entire area
          backgroundPosition: 'center', // Center the image
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          justifyContent: 'center', // Center the container horizontally
          alignItems: 'center', // Center the container vertically
          height: '100px',
        }}
      >
        {/* Left Content }
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 'auto',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography variant="h4" component="h1" fontWeight={700} gutterBottom sx={{ color: 'white' }}>
            Find the Perfect AI Agents for Your Needs
          </Typography>
          <Typography variant="body1" color="#fff" mb={3}>
            Discover, integrate, and orchestrate intelligent agents to transform your workflow
          </Typography>

          <Box sx={{ alignContent: "center" }}>
            <Button
              variant="contained"
              size="large"
              sx={{ color: "#000", backgroundColor: "#fff" ,textTransform:"capitalize"}}
              onClick={onExploreAgentsClick}
            >
              Explore Agents
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
  */
};

export default Banner;
